export default {
  units: [],
  states: [],
  cities: [],
  accessories: [],
  cess: [],
  cessGeneralDuty: [],
  containerSealTypes: [],
  containerSizes: [],
  containerTypes: [],
  countries: [],
  currencies: [],
  declarations: [],
  endUses: [],
  exporterTypes: [],
  exportUnders: [],
  goodsStuffedAt: [],
  gstInTypes: [],
  igstPaymentStatus: [],
  natureOfCargo: [],
  sealTypes: [],
  shipmentTypes: [],
  showFOBIns: [],
  natureOfPayments: [],
  districtCodes: [],
  documentTypeCodes: [],
  termsOfInvoices: [],
  unitPriceIncludes: [],
  eximSchemeCodes: [],
  ritcCodes: [],
  foreignPorts: [],
  homePorts: [],
  drawbackRates: [],
  esanchitSupportingDocs: []
};
